import React = require('react');
import MuiTabs from "material-ui/Tabs/Tabs";
import MuiTab from "material-ui/Tabs/Tab";

import { autoprefixer } from "../../material-ui/autoprefixer";

interface TabsProps extends React.Props<Tabs> {
    value: number;
    onChange?(value: number): void;
}

export default class Tabs extends React.Component<TabsProps, {}> {
    render() {
        const style = this.getStyle();
        return (
            <MuiTabs
                onChange={this.props.onChange}
                tabItemContainerStyle={style.root}
                inkBarStyle={{display: "none"}}
                value={this.props.value}
            >
                {(this.props.children as MuiTab[]).map((tab, i) =>
                    <MuiTab
                        {...tab.props}
                        style={this.props.value === i ? style.selected : style.normal}
                        value={i}
                        key={i}
                    />
                )}
            </MuiTabs>
        );
    }

    private getStyle() {
        const normal = {
            display: 'block',
            fontSize: 14,
            color: "#fff",
            paddingLeft: 12,
            paddingRight: 12,
            width: "auto",
            textTransform: "none",
            fontWeight: 600
        };
        return {
            root: Object.assign(autoprefixer({
                display: 'flex' }), {
                background: "transparent",
                padding: "8px 0 0 0"
            }),
            normal,
            selected: Object.assign({}, normal, {
                background: "#fff",
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                boxShadow: "0 0 1px rgba(0, 0, 0, 0.24), 0 1px 6px rgba(0, 0, 0, 0.12)",
                cursor: "default",
                color: "#3c7bc7"
            })
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/tabs/Tabs.tsx
 **/